import React from 'react';
import { Button, Toast, toastManager } from '@therms/atalaya';

export const CopyJSONSchema = (props) => {
  const handleClick = () => {
    navigator.clipboard.writeText(props.textToCopy);

    toastManager(
      <Toast hideCloseButton>
        <strong>{props.schemaLanguage}</strong> copied to clipboard
      </Toast>,
      { autoClose: 1500, hideProgressBar: true, position: 'bottom-center' },
    );
  };

  return (
    <div>
      <Button size="sm" onClick={handleClick} subtle>
        Copy {props.schemaLanguage}
      </Button>
    </div>
  );
};
